//to-do get codes from i18n messageProperties
export enum ErrorCode {
    UNKNOWN = 'errors.com.epicgames.unknown_error.v2',
    SERVER_ERROR = 'errors.com.epicgames.server_error.v2',
    BAD_REQUEST = 'errors.com.epicgames.bad_request.v2',
    UNAUTHORIZED = 'errors.com.epicgames.unauthorized.v2',
    FORBIDDEN = 'errors.com.epicgames.forbidden.v2',
    NOT_FOUND = 'errors.com.epicgames.not_found.v2',
    CONFLICT = 'errors.com.epicgames.conflict.v2',
    UNSUPPORTED_MEDIA_TYPE = 'errors.com.epicgames.unsupported_media_type.v2',
    SERVICE_UNAVAILABLE = 'errors.com.epicgames.service_unavailable.v2',
    VALIDATION_FAILED = 'errors.com.epicgames.validation.validation_failed.v2',
    CONTACT_SUPPORT = 'errors.com.epicgames.contact_support.v2',
    THROTTLED = 'errors.com.epicgames.throttled',
    CSRF = 'errors.com.epicgames.resubmission',

    // AFFILIATE
    AFF_DIFF_EMAIL = 'epic.affiliate.hyperwallet.error.different.email',
    AFF_ORG_NOT_FOUND = 'epic.affiliate.hyperwallet.error.org.not.found',
    AFF_ACC_NOT_FOUND = 'epic.affiliate.hyperwallet.error.acc.not.found',
    AFF_TAX_NOT_FOUND = 'epic.affiliate.hyperwallet.error.tax.not.found',
    AFF_CONSENT_NOT_FOUND = 'epic.affiliate.hyperwallet.error.tax.consent.not.found',
    AFF_BAL_NOT_FOUND = 'epic.affiliate.hyperwallet.error.balance.not.found',
    AFF_TAX_ID_NOT_FOUND = 'epic.affiliate.hyperwallet.error.tax.identity.not.found',
    AFF_ORG_NOT_APPLICABLE = 'epic.affiliate.hyperwallet.error.org.not.applicable',
    AFF_API_UNAVAILABLE = 'epic.affiliate.hyperwallet.error.api.unavailable',
    AFF_CREATOR_CODE = 'epic.affiliate.ccss.reqs.error',
    AFF_CREATOR_CODE_TAKEN = 'epic.affiliate.ccss.alreadyTaken',
    AFF_TAX_DUPLICATED = 'epic.affiliate.hyperwallet.error.tax.email.duplicated',
    AFF_AGREEMENT_ALREADY_ACCEPTED = 'epic.affiliate.payout.change.acceptance.not.allowed',
    AFF_PAYOUT_INELIGIBLE = 'epic.affiliate.payout.error.ineligible',

    // SOCIAL ERRORS
    SOCIAL_CHANNEL_TAKEN = 'epic.affiliate.social.channels.errors.singleTaken.v2',
    SOCIAL_CHANNEL_INELIGIBLE_MAIN = 'epic.affiliate.social.channels.errors.ineligiblePrimary.v2',
    SOCIAL_CHANNEL_NOT_SAME_AS_SIGNUP = 'epic.affiliate.social.channels.errors.notSameAsSignup.v2',
    SOCIAL_CHANNEL_ALREADY_AUTHENTICATED = 'epic.affiliate.social.channels.errors.alreadyAuthed.v2',
    SOCIAL_CHANNEL_PRIMARY_LOCKED = 'epic.affiliate.social.channels.errors.removePrimary.v2',
    SOCIAL_CHANNEL_SOMETHING_WRONG = 'epic.affiliate.social.channels.errors.somethingWrong.v2',
    SOCIAL_CHANNEL_NOT_LINKED_INSTAGRAM = 'epic.affiliate.social.channels.errors.notLinkedInstagram.v2',
    SOCIAL_CHANNEL_NOT_HAVE_CHANNEL = 'epic.affiliate.social.channels.errors.notHaveChannel.v2',
    SOCIAL_CHANNEL_USER_NOT_FOUND = 'epic.affiliate.social.channels.errors.userNotFound.v2',
    SOCIAL_CHANNEL_PUBLIC_NOT_FOUND = 'epic.affiliate.social.channels.errors.publicNotFound.v2',
    SOCIAL_CHANNEL_ALL_SOCIAL_LINKS_VALID = 'epic.affiliate.social.channels.errors.allSocialLinksValid.v2',
    SOCIAL_CHANNEL_SOMETHING_WRONG_RELOAD = 'epic.affiliate.social.channels.errors.somethingWrongReload.v2',
    SOCIAL_CHANNEL_ERROR = 'epic.affiliate.social.channels.errors.error.v2',
    SOCIAL_CHANNEL_FOLLOWER_COUNT_NOT_MET = 'epic.affiliate.social.channels.errors.unfortunatelySubscriberCount.v2',
    SOCIAL_CHANNEL_NOT_PUBLIC = 'epic.affiliate.social.channels.errors.isNotPublic.v2',
    SOCIAL_CHANNEL_NOT_OWNED = 'epic.affiliate.social.channels.errors.notBelonged.v2',
    SOCIAL_CHANNEL_SUSPENDED = 'epic.affiliate.social.channels.errors.suspended.v2',
    SOCIAL_CHANNEL_UNSUPPORTED = 'epic.affiliate.social.channels.errors.isInvalid.v2',
    SOCIAL_CHANNEL_MATCH_URL = 'epic.affiliate.social.channels.errors.matchUrl.v2',
    SOCIAL_CHANNEL_BAD_OAUTH_TOKEN = 'epic.affiliate.social.channels.errors.badAuthToken.v2',
    SOCIAL_CHANNEL_NO_OAUTH_TOKEN = 'epic.affiliate.social.channels.errors.noAuthToken.v2',
    SOCIAL_CHANNEL_NOT_CONNECTED = 'epic.affiliate.social.channels.errors.notConnected.v2',
    SOCIAL_CHANNEL_PRIMARY_NOT_CONNECTED = 'epic.affiliate.social.channels.errors.primaryNotConnected.v2',
    SOCIAL_CHANNEL_ALREADY_ADDED = 'epic.affiliate.social.channels.errors.alreadyAdded.v2',
    SOCIAL_CHANNEL_CREATE_AFFILIATE_ERROR = 'epic.affiliate.social.channels.errors.createAffiliate.v2',
    SOCIAL_CHANNEL_NO_PAGES_FOUND = 'epic.affiliate.social.channels.errors.pageNotFound.v2',
    SOCIAL_CHANNEL_PAGE_MISMATCH = 'epic.affiliate.social.channels.errors.mismatchPage.v2',
    SOCIAL_CHANNEL_PAGE_SELECT = 'epic.affiliate.social.channels.errors.selectOne.v2',
    SOCIAL_CHANNEL_PAGE_TYPE = 'epic.affiliate.social.channels.errors.pageType.v2',
    SOCIAL_CHANNEL_PAGE_TYPE_INSTAGRAM = 'epic.affiliate.social.channels.errors.pageType.instagram.v2',

    // Talon
    AFF_TALON_VERIFICATION_FAILED = 'epic.affiliate.talon.errors.verification_failed'
}

export interface ServerError {
    errorCode: string;
    numericErrorCode: number;
    errorMessage?: string;
    messageVars?: (string | boolean | number)[];
}

export interface ServerResponse<D = undefined> {
    success: boolean;
    error?: ServerError;
    data?: D;
}
